import { Pipe, PipeTransform } from '@angular/core';
import { SpDateFormatPipe, StepperGroupModel } from '@thehubz/client/core';
import { AnyType } from '@thehubz/shared/model';

@Pipe({
  name: 'keyValueUtil',
  standalone: true,
})
export class KeyValueUtilPipe implements PipeTransform {
  constructor(private spDatePipe: SpDateFormatPipe) {}
  transform(value: AnyType, properties: string, stepper?: StepperGroupModel[], colLabel?: string): string {
    switch (properties) {
      case 'label': {
        const formFields = stepper?.flatMap((step) => step.formFields?.filter((fields) => fields.fieldType !== 'formArray') || []);
        const label = formFields?.find((field) => field.formFieldName === value)?.fieldLabel || '';
        return label;
      }

      case 'value': {
        if (colLabel === 'expiryDate' && !value) {
          return 'No Expiry date';
        }
        if (Array.isArray(value)) {
          return value.map((val) => val.name).join(', ');
        }
        return this.dateCheck(value);
      }
    }
    return value;
  }
  private dateCheck(value: AnyType): string {
    const date = new Date(value);
    if (this.isValidDate(date)) {
      return this.spDatePipe.transform(value.toString()) || '';
    } else {
      return value?.name ?? value;
    }
  }

  private isValidDate(date: Date): boolean {
    return date instanceof Date && !isNaN(date.valueOf());
  }
}
